import React, { useEffect, useRef } from 'react';
import { useSelector } from 'react-redux';

import api from '../../../services/api';
import useStyles from './styles';

function Command({ number, setNumber }) {
  const classes = useStyles();
  const numberRef = useRef();
  const { order } = useSelector(state => state.order);

  useEffect(() => {
    async function get() {
      try {
        const service = api(order.token);
        const res = await service.orderget();
        if (res && res.number > 0) {
          setNumber(res.number);
        } else {
          setNumber('');
          numberRef.current.focus();
        }
      } catch (err) {
        setNumber('');
        numberRef.current.focus();
      }
    }

    get();
  }, []);

  return (
    <div className={classes.root}>
      <span className={classes.title}>Comanda / mesa</span>
      <input
        type="text"
        className={classes.input}
        value={number}
        onChange={e => setNumber(e.target.value)}
        ref={numberRef}
      />
    </div>
  );
}

export default Command;
